import { exportRole } from "../../services/roles";
import { fetchExportRequest, fetchExportSuccess, fetchExportFailure } from "./roleActionCreator";
import { setSnackBarMessage } from "../snackBar/snackBarActionCreator";
import { SNACKBAR_ALERT_DEFAULT_PROPS } from "../../container/Roles/constants";

export async function exportRoles(dispatch: Function, attributeName: string, attributeValues: (string | number)[]) {
    dispatch(fetchExportRequest());

    try {
        const data = await exportRole(attributeName, attributeValues);
        dispatch(fetchExportSuccess(data));
    } catch (error: any) {
        dispatch(fetchExportFailure(error.message));
        dispatch(
            setSnackBarMessage({
                ...SNACKBAR_ALERT_DEFAULT_PROPS,
                message: error.message,
                severity: 'error'
            })
        );
    }
}